import { r as registerInstance, c as createEvent, h } from './index-16dc7dde.js';
import { d as debounce_1 } from './debounce-e28ac3ab.js';
import { D as DEBOUNCED_HANDLER_DELAY } from './request.constants-deb285e0.js';
import { a as isMobile } from './utils-15ad90ec.js';
import './lookups-705fb53e.js';
import './isObject-33fa1780.js';
import './toNumber-5000b45d.js';
import './isSymbol-45bfef0c.js';
import './send-33ade633.js';
import './analytics-765d4daf.js';
import './utils-913bdf8a.js';
import './tslib.es6-2af8cb53.js';
import './_commonjsHelpers-ba3f0406.js';
import './_isIndex-af307327.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';

const sustainabilityPillarCss = "*{box-sizing:border-box}.sustainability-pillar-tooltip-wrapper{overflow:hidden;width:100%}.sustainability-pillar{display:flex;flex-direction:column;align-items:center;text-align:center}.large-pillar{width:142px}.small-pillar{width:93px}.sustainability-pillar__icon{max-width:51px;height:auto}.sustainability-pillar__label{font-size:12px;line-height:1.5;display:block;font-weight:normal;color:#333333;margin-top:0}.pillar-hidden{height:0;transition:height 0.3s ease}.pillar-shown{height:91px;transition:height 0.3s ease;text-align:center}.sustainability-pillar-tooltip{text-align:start}";

let SustainabilityPillar = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.scrollToSustainability = createEvent(this, "scrollToSustainability", 7);
    this.withAnchorLinks = false;
    this.isLongWordPresent = false;
    this.isMobile = isMobile();
    this.showTooltip = false;
    this.showModal = true;
    this.position = 'top';
    this.setPillarContentRef = (el) => {
      this.pillarContentEl = el;
    };
    this.windowResizeHandler = () => {
      this.isMobile = isMobile();
    };
    this.debouncedHandleResize = debounce_1(this.windowResizeHandler, DEBOUNCED_HANDLER_DELAY);
    this.scrollToSustainabilitySector = (event) => {
      event.preventDefault();
      this.scrollToSustainability.emit();
    };
    this.handleLinkClick = (event) => {
      this.scrollToSustainabilitySector(event);
      this.showTooltip = false;
      this.showModal = false;
    };
    this.handleTooltipOpen = () => {
      this.showTooltip = true;
    };
  }
  handlePillarDataChange(newValue, oldValue) {
    if (oldValue !== newValue) {
      this.pillarData = newValue;
    }
  }
  connectedCallback() {
    window.addEventListener('resize', this.debouncedHandleResize);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.debouncedHandleResize);
  }
  componentWillLoad() {
    this.pillarData = (this === null || this === void 0 ? void 0 : this.data) || {};
  }
  renderPillar() {
    var _a, _b, _c, _d;
    return (h("div", { slot: "tooltip-activator", class: `sustainability-pillar ${this.isLongWordPresent ? 'large-pillar' : 'small-pillar'} ${!this.isMobile && ((_a = this === null || this === void 0 ? void 0 : this.pillarData) === null || _a === void 0 ? void 0 : _a.isHidden) ? 'pillar-hidden' : 'pillar-shown'}` }, h("img", { class: "sustainability-pillar__icon", width: "51", height: "51", src: (_b = this === null || this === void 0 ? void 0 : this.pillarData) === null || _b === void 0 ? void 0 : _b.absoluteUrl, alt: (_c = this === null || this === void 0 ? void 0 : this.pillarData) === null || _c === void 0 ? void 0 : _c.alt }), h("span", { class: "sustainability-pillar__label" }, (_d = this === null || this === void 0 ? void 0 : this.pillarData) === null || _d === void 0 ? void 0 : _d.pillarLabel)));
  }
  renderDesktopContent() {
    var _a, _b;
    return (h("div", { slot: "tooltip-content", class: "sustainability-pillar-tooltip", ref: this.setPillarContentRef }, h("p", null, (_a = this === null || this === void 0 ? void 0 : this.pillarData) === null || _a === void 0 ? void 0 : _a.tooltip), this.withAnchorLinks && (h("se-link", { onClick: this.handleLinkClick, option: "external" }, (_b = this === null || this === void 0 ? void 0 : this.pillarData) === null || _b === void 0 ? void 0 : _b.learnMoreBelow))));
  }
  renderMobileContent() {
    var _a, _b, _c;
    return (h("div", { slot: "tooltip-content", ref: this.setPillarContentRef }, h("h4", { style: { marginBottom: '18px' } }, (_a = this === null || this === void 0 ? void 0 : this.pillarData) === null || _a === void 0 ? void 0 : _a.pillarLabel), h("p", { style: { margin: '14px 0' } }, (_b = this === null || this === void 0 ? void 0 : this.pillarData) === null || _b === void 0 ? void 0 : _b.tooltip), this.withAnchorLinks && (h("pes-cta-button", { type: "secondary", size: "small", icon: "arrow4_down", iconPosition: "end", onClick: this.handleLinkClick }, (_c = this === null || this === void 0 ? void 0 : this.pillarData) === null || _c === void 0 ? void 0 : _c.learnMoreBelow))));
  }
  render() {
    var _a;
    if (!((_a = this === null || this === void 0 ? void 0 : this.pillarData) === null || _a === void 0 ? void 0 : _a.tooltip))
      return this.renderPillar();
    return (h("pes-tooltip-wrapper", { showTooltip: this.showTooltip, onDidOpen: this.handleTooltipOpen, position: this.position, class: "sustainability-pillar-tooltip-wrapper", isSustainabilityPortal: true, showModal: this.showModal }, this.renderPillar(), this.isMobile ? this.renderMobileContent() : this.renderDesktopContent()));
  }
  static get watchers() { return {
    "data": ["handlePillarDataChange"]
  }; }
};
SustainabilityPillar.style = sustainabilityPillarCss;

export { SustainabilityPillar as pes_sustainability_pillar };
